import { validationConstants } from '../constants'
import { validationRequests } from '../../services'
import { handleErrorMessage } from '../../utils'

export const validationActions = {}

validationActions.ValidatePINActivateUser = (data) => {
    return dispatch => {
        dispatch(request())
        validationRequests.ValidatePINActivateUser(data)
            .then(
                valActivaUserData => dispatch(success(valActivaUserData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: validationConstants.PINACTIVATEUSER_REQUEST }
    }

    function success(valActivaUserData) {
        return { type: validationConstants.PINACTIVATEUSER_SUCCESS, valActivaUserData }
    }

    function failure(error) {
        return { type: validationConstants.PINACTIVATEUSER_FAILURE, error }
    }
}

validationActions.ValidateCAPTCHA = (data) => {
    return dispatch => {
        dispatch(request())
        validationRequests.ValidateCAPTCHA(data)
            .then(
                captchaData => dispatch(success(captchaData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: validationConstants.VALCAPTCHA_REQUEST }
    }

    function success(captchaData) {
        return { type: validationConstants.VALCAPTCHA_SUCCESS, captchaData }
    }

    function failure(error) {
        return { type: validationConstants.VALCAPTCHA_FAILURE, error }
    }
}

validationActions.ValidatePINChangePassword = (data) => {
    return dispatch => {
        dispatch(request())
        validationRequests.ValidatePINChangePassword(data)
            .then(
                valChangPassData => dispatch(success(valChangPassData)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: validationConstants.VALIDATECHANGPASS_REQUEST }
    }

    function success(valChangPassData) {
        return { type: validationConstants.VALIDATECHANGPASS_SUCCESS, valChangPassData }
    }

    function failure(error) {
        return { type: validationConstants.VALIDATECHANGPASS_FAILURE, error }
    }
}

validationActions.SendDocumentValidation = (data) => {
    return dispatch => {
        dispatch(request())
        validationRequests.SendDocumentValidation(data)
            .then(
                valDoc => dispatch(success(valDoc)),
                error => dispatch(failure(handleErrorMessage(error)))
            )
    }

    function request() {
        return { type: validationConstants.VALIDATE_DOC_REQUEST }
    }

    function success(valDoc) {
        return { type: validationConstants.VALIDATE_DOC_SUCCESS, valDoc }
    }

    function failure(error) {
        return { type: validationConstants.VALIDATE_DOC_FAILURE, error }
    }
}